import { useEffect, useState } from 'react';
import { getTrialUserEmails, UserKeys } from '../../api/users-api';
import { useQuery } from '@tanstack/react-query';
import AddUserDialog from './add-trial-user-dialog';
import { Messages } from '../../utils/message-constants';
import Button from '@mui/material/Button';
import PersonAdd from '@mui/icons-material/PersonAdd';

export default function TrialButton() {
  const [openAddUser, setOpenAddUser] = useState(false);

  const { data: trialUsers } = useQuery({
    queryKey: [UserKeys.TrialUserEmails],
    queryFn: () => getTrialUserEmails(),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('trial users'),
    },
  });

  useEffect(() => {
    if (!trialUsers) return;

    if (trialUsers.length === 0) {
      setOpenAddUser(true);
    }
  }, [trialUsers]);

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        sx={{
          borderRadius: 5,
        }}
        startIcon={<PersonAdd fontSize="medium" />}
        onClick={() => setOpenAddUser(true)}
        disabled={trialUsers?.length === 5}
      >
        Add Trial Users: {trialUsers?.length}/5
      </Button>
      <AddUserDialog
        open={openAddUser}
        handleClose={() => setOpenAddUser(false)}
        trialUsers={trialUsers || []}
      />
    </>
  );
}
